/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Grid, Tooltip, Typography, Divider, IconButton, Backdrop, Avatar, Paper, Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button } from '@material-ui/core'

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";
import HighlightOff from "@material-ui/icons/HighlightOff";

import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import Add from "@material-ui/icons/Add";
import Refresh from "@material-ui/icons/Refresh";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ScheduleIcon from '@material-ui/icons/Schedule';
import Cancel from "@material-ui/icons/Cancel";
import Visibility from "@material-ui/icons/Visibility"

import { DeleteConfirmationDialog } from "./../Utilities/DeleteConfirmationDialog";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartNetwork, faSnooze, faMicrochip, faTrash, faCalendar } from '@fortawesome/pro-duotone-svg-icons'
import Scheduler from '../Scheduler/Scheduler'
import AddWorkflow from '../CreateWorkflow/AddWorkflow'
import Actions from './../../fluid/Actions/ActionFactory.js'

import Event from '@material-ui/icons/Event'
import { CancelOutlined } from '@material-ui/icons';

import SecureWrapper from "../Security/SecureWrapper";
import { allowedByOpop } from '../Security/SecureCheck';

import { faHourglassEnd } from "@fortawesome/pro-duotone-svg-icons";
const clone = require('rfdc')()



const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      // primary: {
      //     main: "#FF6600",
      //     contrastText: "#FFFFFFFF"
      // },
      secondary: {
        main: "#dc004e",
      },
    },
});



const bot_input = [
    {
        "id": 1,
        "name": "bot one"
    }

]

const styles = theme => ({
    '@keyframes pulsate' : {
        from : {
            opacity : 0.25
        },
        to : {
            opacity : 1.0
        }
    },
    active : {
        color : "#4caf50",
        fontSize : '15px'
    },
    running : {
        color : "#4caf50",
        fontSize : '15px',
        animation : '$pulsate 250ms infinite alternate'
    },
    deactive : {
        color : "#FF8C02",
        fontSize : '15px',
        animation : '$pulsate 3000ms infinite alternate'
    },
    backdrop: {
        zIndex: "10",
        color: '#fff',
    },
    "@keyframes spin": {
        from: { transform: "rotate(0deg)" },
        to: { transform: "rotate(360deg)" },
    },
    "@keyframes slide": {
        from: { left: "0px" },
        tp: { right: "30px" },
    },
    in_progress: {
        color: "#039be5",
        textAlign: "center",
        animation: "$spin 2s infinite linear",
    },
    in_progress_dt: {
        color: "#039be5",
        textAlign: "center",
        animation: "$slide 2s infinite linear",
    },
})

class WFList extends Component {
    state = {
        wf_data : [],
        adding_workflow: false,
        wf_name: null,
        isLoading: true,
        deletingItem: {},
        errorOpen: false,
        errorInfo: {},
        confirmDeleteDialogOpen: false,
        botInputParamDialogOpen: false,
        botOutputDialogOpen: false,
        botMessageDialogOpen: false,
        selectedRowIndex : null,
        selectedWF : null
    }

    componentDidMount () {
        this.getWorkflows();
        if (this.state.selectedWF !== null) {
            this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedWF)]], this.tableRef.current.props.detailPanel)
        }
    }

    componentDidUpdate (prevProps, prevState) {
       
        if(prevState.selectedWF !== null){
            if (this.state.selectedWF !== null && this.state.selectedWF === prevState.selectedWF ) {
              this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedWF)]], this.tableRef.current.props.detailPanel)
            } else if(this.state.selectedWF !== null && this.state.selectedWF !== prevState.selectedWF) {
              this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedWF)]], this.tableRef.current.props.detailPanel)
            } else{
              this.setState({ selectedWF:  null})
            }
        }
    }
    
    
    tableRef = React.createRef()

    getWorkflows = () => {
        this.setState({ ...this.state, isLoading: true}, () => {
            Actions('http_request', {
                url : '/sainapse/workflow',
                method : 'get',
                data : {}
            }).then(res => {
                this.setState({...this.state, wf_data: res.data.result, isLoading: false }, () => {
                })
            }).catch((err) => {
                console.log(err)
                this.setState({
                    errorOpen: true,
                    errorInfo: err,
                })
            })
        })
    }

    renderStatus = (row_data, status, name) => {
        const { classes } = this.props
        let  { workflow_execution_status } = row_data;	
        //let status = workflow_execution_status ;
        // if( workflow_execution_status_object.length > 0 ){
        //     status  = workflow_execution_status_object[0].status;
        // }

        if (status === "Queued") {
            return (
              <Tooltip title={name + " || Queued"}>
                <QueryBuilderIcon fontSize="small" style={{ color: "#FF6600" }} />
              </Tooltip>
            );
        } else if (status === "InProgress") {
            return (
              <Tooltip title={name + " || In Progress"}>
                <ArrowRightAltIcon
                  fontSize="small"
                  className={classes.in_progress_dt}
                />
              </Tooltip>
            );
        } else if (status === "Aborted") {
            return (
              <Tooltip title={name + " || Aborted"}>
                <ErrorOutlineIcon fontSize="small" style={{ color: "#f44336" }} />
              </Tooltip>
            );
        } else if (status === "Completed") {
            return (
              <Tooltip title={name + " || Completed"}>
                <CheckCircleOutlined
                  fontSize="small"
                  style={{ color: "#4caf50" }}
                />
              </Tooltip>
            );
        } else if (status === "Timeout"){
            return (
                <Tooltip title={"Timeout"}> 
                    <IconButton size = 'small'>   
                        <FontAwesomeIcon style = {{color : "red"}} icon = {["fad", "hourglass-end"]}/>
                    </IconButton> 
                </Tooltip>
            );
        }
    }

    setSchedule = (schedule, wf_name) => {
        // let wf_data = clone(this.state.wf_data);
        // let  = wf_data.findIndex(wf => wf.name === wf_name)
        // wf_data[wf_index].scheduleJob = schedule

        Actions('http_request', {
            url : '/sainapse/schedule',
            method : 'post',
            data : {
                cron_expression: schedule.cron_expression,
                end_time: schedule.end_time,
                group: schedule.group_name,
                name: schedule.job_name,
                start_time: schedule.start_time,
                workflow_request: wf_name
            }
        }).then(res => {
            // this.setState({
            //     ...this.state,
            //     wf_data : wf_data
            // })
            this.getWorkflows()
        }).catch((err) => {
            console.log(err)
            this.setState({
                errorOpen: true,
                errorInfo: err,
            })
        })
    }

    handlePopupClose = () => {
        this.setState({ adding_workflow: false }, () => {
            this.getWorkflows()
        })
    }

    runWorkflow = (wf_name) => {
        Actions('http_request', {
            url : '/sainapse/workflow/' + wf_name + "/run",
            method : 'post',
            data : {}
        }).then(res => {
            this.getWorkflows()
        })
    }

    cancelDelete = () => {
      this.setState({ deletingItem: {}, confirmDeleteDialogOpen: false });
    };
  
    confirmDelete = () => {
      this.setState({ confirmDeleteDialogOpen: false });
  
      Actions("http_request", {
        url: "/sainapse/workflow/" + this.state.deletingItem.name,
        method: "delete",
        data: {},
      })
        .then((res) => {
          this.getWorkflows();
          this.setState({ deletingItem: {} });
        })
        .catch((err) =>
          this.setState({
            deletingItem: {},
            errorOpen: true,
            errorInfo: err,
          })
        );
    };
  
    //delete
    deleteWorkflow = (rowData) => {
        if (this.state.selectedWF === rowData.name) {
            this.setState({ deletingItem: rowData, confirmDeleteDialogOpen: true, selectedWF : null });
        } else {
            this.setState({ deletingItem: rowData, confirmDeleteDialogOpen: true });
        }
    };
  
    //error
    handleErrorClose = () => {
      this.setState({ errorOpen: false, errorInfo: {} });
    };

    getWFRunnable = (row_data) => {
        if (row_data.setup_complete) {
            if (row_data.workflow_execution_status_object.length > 0) {
                if (row_data.workflow_execution_status !== 'InProgress') {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        } else {
            return false
        }
    }

    terminateWorkflow = ( wf_name ) => {
        Actions('http_request', {
            url : '/sainapse/workflow/' + wf_name + "/terminate",
            method : 'get',
            data : {}
        }).then(res => {
            if(res.data.result === true ){
                this.getWorkflows();
            }
            
        }).catch(err => {
            this.setState({
                errorOpen: true,
                errorInfo: err,
            })
        })
    }

    getDisableStatus= (name) => {
    
        return !allowedByOpop({
          operation : "/sainapse/workflow/{name}",
          method : "DELETE",
          operands : [
            {
              attrName: "name",
              value : name
        }]
        })
      };

      getExecutionDisableStatus= (name) => {
    
        return !allowedByOpop({
          operation : "/sainapse/workflow/{name}/run",
          method : "POST",
          operands : [
            {
              attrName: "name",
              value : name
        }]
        })
      };

    renderActions = (row_data) => {
            let wf_name = row_data.name;
    if (
      row_data.name !== this.state.deletingItem.name ||
      this.state.confirmDeleteDialogOpen
    ) {
        return (
            <div style = {{
                width : '100%',
                height : '100%',
                display : 'flex',
                flexDirection : 'row',
                justifyContent : 'center',
                alignItems : 'center'
            }}>
                <Tooltip title = "Run">
                    <IconButton 
                        size="small" 
                        style={{color : this.getWFRunnable(row_data) && !this.getExecutionDisableStatus(wf_name) ? "#4caf50" : "rgb(0,0,0,0.3)", marginRight: "0px" }} 
                        disabled = {!this.getWFRunnable(row_data) && this.getExecutionDisableStatus(wf_name)}
                        onClick = {() => this.runWorkflow(wf_name)}
                    >
                        <PlayArrowIcon fontSize = 'small'/>
                    </IconButton>
                </Tooltip>
                {
                    row_data && row_data.workflow_execution_status  === 'InProgress' ? (
                        <Tooltip title = "Terminate">
                            <IconButton 
                                size="small" 
                                style={{color : "#f44336", marginRight: "0px" }} 
                                onClick = {() => this.terminateWorkflow(wf_name)}
                            >
                                <CancelOutlined fontSize = 'small' />
                            </IconButton>
                        </Tooltip>
                    ): null
                }
                <Tooltip title="Delete" arrow>
                    <IconButton
                    size="small"
                    style={{ color: !this.getDisableStatus(wf_name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
                    onClick={() => this.deleteWorkflow(row_data)}
                    disabled = {this.getDisableStatus(wf_name)}
                    >
                        <DeleteOutline fontSize="small" />
                    </IconButton>
                </Tooltip>
                {/* <Tooltip title="Schedule" arrow>
                    <IconButton
                    size="small"
                    style={{ color: "#039be5", marginRight: "0px" }}
                    >
                        <ScheduleIcon fontSize="small" />
                    </IconButton>
                </Tooltip> */}
            </div>
        )
      } else {
        return <Typography variant="overline">Deleting...</Typography>;
      }
    }

    goToCreateWorkflow = () => {
        this.setState({ adding_workflow: true })
    }

    pauseJob = (row_data) => {
        let { scheduleJob } = row_data;
        let { group_name , job_name } = scheduleJob ;
        
    
        Actions('http_request', {
            url : '/sainapse/schedule/pause?groupName=' + group_name + "&jobName=" + job_name,
            method : 'post',
            data : {}
        }).then(res => {
            this.getWorkflows();
        }).catch((err) => {
            console.log(err)
            this.setState({
                errorOpen: true,
                errorInfo: err,
            })
        })
    }

    resumeJob = (row_data) => {
        let { scheduleJob } = row_data;
        let { group_name , job_name } = scheduleJob ;
        Actions('http_request', {
            url : '/sainapse/schedule/resume?groupName=' + group_name + "&jobName=" + job_name,
            method : 'post',
            data : {}
        }).then(res => {
            this.getWorkflows();
        }).catch((err) => {
            console.log(err);
            this.setState({
                errorOpen: true,
                errorInfo: err,
            })
        })
    }

    deleteJob = (row_data) => {
        let { scheduleJob } = row_data;
        let { group_name , job_name } = scheduleJob ;
        Actions('http_request', {
            url : '/sainapse/schedule?groupName=' + group_name + "&jobName=" + job_name,
            method : 'delete',
            data : {}
        }).then(res => {
            this.getWorkflows();
        }).catch((err) => {
            this.setState({
                errorOpen: true,
                errorInfo: err,
            })
        })
    }

    viewInputParameters = ( script_input ) => {
        const { classes } = this.props;
        const input = bot_input;
        this.setState({
            botInputParamDialogOpen : true,
            botInputParams: script_input
        }, () => {
        
        })     
    }

    
    viewOutputParameters = ( bot_output) => {
        const { classes } = this.props;
        this.setState({
            botOutputDialogOpen : true,
            botOutput: bot_output
        }, () => {
        
        })
        
    }

    viewMessage = ( botMessage ) => {
        this.setState({... this.state, botMessageDialogOpen: true, botMessage: botMessage })
    }

    handleBotInputDialogClose = () => {
        this.setState({ ...this.state, botInputParamDialogOpen: false })
    }

    handleBotOutputDialogClose = () => {
        this.setState({ ...this.state, botOutputDialogOpen: false })
    }

    handleBotMessageDialogClose = () => {
        this.setState({ ...this.state, botMessageDialogOpen: false})
    }

    
    
    renderWorkflowExecutionStatus = (row_data) => {
        if (this.state.selectedWF !== row_data.name ) {
            this.setState({...this.state, selectedWF : row_data.name}, () => {
              
            })
          } else {
           
          }
        const { workflow_execution_status_object } = row_data;
        const { bot_execution_status } = workflow_execution_status_object;
        const workflow_type = row_data.type;
        return (
            <MaterialTable
                title="Executions"
                style={{ margin: "1%", marginLeft: "3%" }}
                icons={table_icons}
                columns={[
                    { title: "Execution ID", field: "id"},
                    { title: "Start Time", field: "start_time"  , type: "datetime"},
                    { title: "Request Time", field: "request_time"  , type: "datetime" },
                    { title: "End Time", field: "end_time" , type: "datetime"},
                    { title: "Status", field: "status" , render : (rowData) => {
                        return this.renderStatus(rowData, rowData.status, rowData.id)
                    }},
                    { title: "Additional Info", field: "message" }
                ]}
                data = {workflow_execution_status_object}
                detailPanel={(rowData) => {
                    //set currently selected ic name that will be used to handle iu crud operations.
                    // this.setState({currentICName: rowData.name})
                    return this.renderScriptStatus(rowData, rowData.bot_execution_status, workflow_type)
                }}
                options={{
                    search: false,
                    toolbar: true,
                    showTitle: true,
                    paging: true,
                    titleStyle : {
                        fontSize: "10px"
                    }
                }}
            />
        );
    }

    renderScriptStatus = (row_data, bot_execution_status, workflow_type) => {
        if( bot_execution_status !== null && workflow_type === 'Action' && bot_execution_status.length > 0 ){
            return (
                <MaterialTable
                    title="Script Status"
                    style={{ margin: "1%", marginLeft: "3%" }}
                    icons={table_icons}
                    columns={[
                        { title: "Script Name", field: "bot_name", render: (rowData) => {
                            return rowData.bot_name
                        }},
                        { title: "Start Time", field: "start_time" , type: "datetime"},
                        { title: "End Time", field: "end_time", type: "datetime" },
                        { title: "Status", field: "status" , render : (rowData) => {
                            return this.renderStatus(rowData, rowData.status, rowData.bot_name)
                        }},
                        {
                            title: "Input", field: "input", render: ( rowData) => {
                                return (
                                    <ThemeProvider theme={blue_theme}>
                                        {
                                            rowData.input && rowData.input.length > 0 ? (
                                                <Fragment>
                                                    <Typography variant = 'body2' color = 'primary'>{rowData.Input.substring(0,25)}</Typography>
                                                    {
                                                        rowData.input.length > 20 &&  <Typography style = {{cursor : 'pointer'}} variant = 'body2' color = "primary" onClick = {(event) => { event.preventDefault();this.viewInputParameters(rowData.input)}}>...show more</Typography>
                                                   
                                                    }
                                                </Fragment>
                                            ) : (
                                                <Typography variant = 'body2'>This Script does not have input parameters</Typography>
                                            )
                                        }
                                    </ThemeProvider>
                                )
                            }
                        },
                        {
                            title: "Output", field: "output", render: ( rowData) => {
                                return (
                                    <ThemeProvider theme={blue_theme}>
                                        {
                                            rowData.output && rowData.output.length > 0 ? (
                                                <Fragment>
                                                    <Typography variant = 'body2'>{rowData.output.substring(0,20)}</Typography>
                                                    {
                                                        rowData.output.length > 20 && <Typography style = {{cursor : 'pointer'}} variant = 'body2' color = "primary" onClick = {(event) => { event.preventDefault();this.viewOutputParameters(rowData.output)}}>...show more</Typography>
                                                   
                                                    }
                                                </Fragment>
                                            ) : (
                                                <Typography variant = 'body2' color = 'primary'>This Script does not have output</Typography>
                                            )
                                        }
                                    </ThemeProvider>
                                )
                            }
                        },
                        {
                            title: "Additional Info", field: "message", render: ( rowData ) => {
                                return (
                                    <ThemeProvider theme={blue_theme}>
                                        {
                                            rowData.message && rowData.message.length > 0 && (
                                                <Fragment>
                                                    <Typography variant = 'body2'>{rowData.message.substring(0,20)}</Typography>
                                                    {
                                                        rowData.message.length > 20 && <Typography style = {{cursor : 'pointer'}} variant = 'body2' color = "primary" onClick = {(event) => { event.preventDefault();this.viewMessage(rowData.message)}}>...show more</Typography>
                                                   
                                                    }
                                                </Fragment>
                                            ) 
                                        }
                                    </ThemeProvider>
                                )
                            }
                        }
                    ]}
                    data = {bot_execution_status}
                    options={{
                        search: false,
                        toolbar: true,
                        showTitle: true,
                        paging: false,
                        titleStyle : {
                            fontSize: "10px"
                        }
                    }}
                />
            );
        } else {
            return null;
        }
      
       

    }

    renderBotInputParams = () => {
        return (
            <Dialog open={this.state.botInputParamDialogOpen} style = {{width : '85vw', height : '85vh'}}>
                <DialogTitle id="alert-dialog-title">Script Input</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.botInputParams ? this.state.botInputParams : "This script does not have any input parameters"}
                        </DialogContentText>

                    
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                            console.log("close");
                            this.handleBotInputDialogClose();
                            }}
                            color="secondary"
                        >
                            close
                        </Button>
                    </DialogActions>
            </Dialog>
        )
        
    }

    renderBotOutput = () => {
        return (
            <Dialog open={this.state.botOutputDialogOpen} style = {{width : '85vw', height : '85vh'}}>
                <DialogTitle id="alert-dialog-title">Script Output</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.botOutput ? this.state.botOutput : "This script does not have any output"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                            console.log("close");
                            this.handleBotOutputDialogClose();
                            }}
                            color="secondary"
                        >
                            close
                        </Button>
                    </DialogActions>
            </Dialog>
        )
        
    }

    renderBotMessage = () => {
        return (
            <Dialog open={this.state.botMessageDialogOpen} style = {{width : '85vw', height : '85vh'}}>
                <DialogTitle id="alert-dialog-title">Message</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.botMessage ? this.state.botMessage : "No message"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                            console.log("close");
                            this.handleBotMessageDialogClose();
                            }}
                            color="secondary"
                        >
                            close
                        </Button>
                    </DialogActions>
            </Dialog>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <Fragment>
                 <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/workflow",
                                        method : "GET",
                                        operands : []
                                    }}
                                    shouldRenderErrorMessage = {true}
                                    errorMessage = "User does not have sufficient privileges"
                                    textVariant = "subtitle2"
                                    >
                <MaterialTable
                    tableRef={this.tableRef}
                    style={{width : '100vw', height: "calc(100vh - 48px)" }}
                    title="Workflows"
                    icons={table_icons}
                    columns = {[
                        {title : "Name", field : "name", cellStyle : {
                            textAlign : 'left'
                        }},
                        {
                            title: "Description", field: "description", cellStyle : {
                                textAlign : 'left'
                        }},
                        {title : "Created Date", field : "created_date", type: "datetime"},
                        {title : "Updated Date", field : "updated_date", type: "datetime", defaultSort: "desc"},
                        {title: "Setup Complete", field: "setup_complete", 
                            render: (rowData) => {
                                if (rowData.setup_complete === false) {
                                    return (
                                    <Tooltip title = "Setup is not complete">
                                        <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                                    </Tooltip>
                                    );
                                } else {
                                    return (
                                        <Tooltip title = "Setup Complete">
                                            <CheckCircleOutlined
                                                fontSize="small"
                                                style={{ color: "#4caf50" }}
                                            />
                                        </Tooltip>
                                    );
                            
                                }
                            }
                        },
                        {title : "Workflow Status", field : "workflow_execution_status", render : (rowData) => {
                            return this.renderStatus(rowData, rowData.workflow_execution_status, rowData.name)
                        }},
                        {title : "Schedule", field : "scheduleJob", disableClick : true, render : (rowData) => {
                            console.log("Schedule Object : ", rowData.scheduleJob)
                            return (
                                <div style = {{width : '350px'}}>
                                    <Scheduler 
                                        key = {new Date().getTime()} 
                                        scheduleJob = {rowData.scheduleJob}
                                        group_name = "Workflow_execution"
                                        submit_schedule = {(schedule) => this.setSchedule(schedule, rowData.name)}
                                        pause = {(job_name) => this.pauseJob(rowData)}
                                        resume = {(job_name) => this.resumeJob(rowData)}
                                        delete = {(job_name) => this.deleteJob(rowData)}
                                    />
                                </div>
                            )
                        }},
                        
                        {title : "Actions", field : "actions", disableClick : true, render : (rowData) => {
                            return this.renderActions(rowData)
                        }}
                    ]}
                    data = {this.state.wf_data}
                    
                    options={{
                        search: true,
                        cellStyle: {
                            height: "5vh",
                            paddingTop: 0,
                            paddingBottom: 0,
                        },
                        toolbarButtonAlignment: "right",
                        paging: false,
                        pageSize: 10,
                        pageSizeOptions: [10, 20, 50],
                        headerStyle: {
                        height: "7vh",
                        padding: 0,
                        margin: 0,
                        textAlign: "center",
                        backgroundColor: "#F0F0F0",
                        lineHeight: "1.25",
                        },
                        maxBodyHeight: "78vh",
                        detailPanelType: "single",
                        draggable: false,
                    }}
                    isLoading={this.state.isLoading}
                    onRowClick={(event, rowData, togglePanel) => {
                       
                        if (this.state.selectedWF !== rowData.name) {
                          this.setState({...this.state, selectedWF : rowData.name}, () => {
                          })
                        } else {
                          this.setState({...this.state, selectedWF : null}, () => togglePanel())
                        }
                    }}
                    detailPanel={(rowData) => {
                        //set currently selected ic name that will be used to handle iu crud operations.
                        // this.setState({currentICName: rowData.name})
                        return ( 
                            <Fragment>
                                { this.renderWorkflowExecutionStatus(rowData) }
                            </Fragment> 
                        );
                    }}
                    components={{
                        Toolbar: (props) => (
                        <Fragment>
                            <MTableToolbar {...props} />
                            <Divider />
                            <div
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row-reverse",
                                height: "5vh",
                                alignContent: "flex-end",
                            }}
                            >
                            <ThemeProvider theme={blue_theme}>
                            <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/workflow",
                                        method : "GET",
                                        operands : []
                                    }}
                                    >
                                <Tooltip title="Refresh" onClick={this.getWorkflows}>
                                <IconButton color="primary">
                                    <Refresh />
                                </IconButton>
                                </Tooltip>
                                </SecureWrapper>
                                <SecureWrapper
                                    access_object = {{
                                        operation : "/sainapse/workflow",
                                        method : "POST",
                                        operands : []
                                    }}
                                    >
                                <Tooltip title="Add Workflow">
                                    <IconButton
                                        color="primary"
                                        onClick={this.goToCreateWorkflow}
                                    >
                                    <Add/>
                                </IconButton>
                                </Tooltip>
                                </SecureWrapper>
                            </ThemeProvider>
                            </div>
                            <Divider />
                        </Fragment>
                        ),
                    }}
                />
                </SecureWrapper>
                {
                    this.state.adding_workflow === true && (
                        <Backdrop className = {classes.backdrop} style = {{width : '100vw', height : '100vh'}} open = {this.state.adding_workflow}>
                            <AddWorkflow wf_name={this.state.wf_name} close = { this.handlePopupClose}/>
                        </Backdrop>
                    )
                }

                {
                    this.state.adding_scheduleJob == true && (
                        <Backdrop className = {classes.backdrop} style = {{width : '100vw', height : '100vh'}} open = {this.state.adding_scheduleJob}>
                            <AddWorkflow wf_name={this.state.wf_name} close = { this.handleScheduleJobPopupClose}/>
                        </Backdrop>
                    )
                }
                {this.state.errorOpen ? (
          <ErrorMessageAlert
            open={this.state.errorOpen}
            handleClose={this.handleErrorClose}
            errorInfo={this.state.errorInfo}
          ></ErrorMessageAlert>
        ) : null}
        <DeleteConfirmationDialog
          open={this.state.confirmDeleteDialogOpen}
          name={this.state.deletingItem.name}
          type={"Workflow"}
          confirmDeleteHandler={this.confirmDelete}
          cancelDeleteHandler={this.cancelDelete}
        ></DeleteConfirmationDialog>
        {this.renderBotInputParams()}
        {this.renderBotOutput()}
        {this.renderBotMessage()}
        
        
            </Fragment>
        );
    }
}

export default withRouter(withStyles(styles)(WFList));
